(() => {
    document.addEventListener("DOMContentLoaded", function () {

        const $get = id => document.getElementById(id);

        const oldTable = $get("oldTable");
        if (oldTable !== undefined && oldTable !== null) oldTable.style.display = "none";

        const newTable = $get("mainTable");

        const tJsonW = $get("JSONThickness") as HTMLTextAreaElement; 
        let thicknesses = JSON.parse(tJsonW.value);

        const tJsonTitle = $get("JSONTitle") as HTMLTextAreaElement;
        const titleData = JSON.parse(tJsonTitle.value);

        const tJson = $get("JSONData") as HTMLTextAreaElement;
        const compactionData = tJson.value;
        
        const allData = JSON.parse(compactionData);
        const materialTypes: string[] = [];

        for (const x in allData) {
            materialTypes.push(allData[x].TypeOfMaterial);
        }

        const container = $get("mainTable");

        let innerHTML = `
            <div class="row">
                <div class="form-group col-lg-7 mt-2 mb-1">
                    <label for="materialTypeDropdown">Type of material</label>
                    <div>
                        <span id="materialTypeDropdown"> </span>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-lg-7 mt-2">
                    <label for="">Minimum passes/lift for compacted lift thickness up to:</label><br />

                        `;

        thicknesses.forEach((x) => {
            const mmLabel = x.replace(" mm", "mm");  // spaces before 'mm' look odd here
            innerHTML += `<input style="margin-left: 7px" type="checkbox" name="ww" value="${x}" />&nbsp;<b>${mmLabel}</b> `
        }
        );

        innerHTML += `
                    
               </div>
            </div>
            <div class="row mt-1">
                <div class="form-group col-lg-7 mt-1">
                    <button id="btnShowRequirements"
                                name="command"
                                value="search"
                                type="submit"
                                class="ml-1 mt-2 btn btn-primary">
                            Show requirements
                    </button>
                </div>
           </div>


            <div id="tblRequirements" class="mt-3"></div>
        `

        container.innerHTML = innerHTML;

        const materialTypeSelect = document.createElement("select");
        materialTypeSelect.id = "materialTypeSelect";
        materialTypeSelect.className += "ml-1 form-control form-select";
        materialTypeSelect.style.fontWeight = "bold";
        $get("materialTypeDropdown").appendChild(materialTypeSelect);


        for (let i = 0; i < materialTypes.length; i++) {   // there is only one
            const option = document.createElement("option");
            option.value = String(i);
            option.text = materialTypes[i];  
            materialTypeSelect.appendChild(option);
        }

        const btnShowRequirementsClick = function (event) {
            const e = $get("materialTypeSelect") as HTMLSelectElement;
            const sel = e.selectedIndex;
            const opt = e.options[sel];
            const rtValue: number = + opt.value;

            const dataRow = allData[rtValue];

            const lValues: string[] = [];

            $("input:checkbox[name=ww]:checked").each(function () {
                lValues.push(String($(this).val()));
            });

            const invalidSelection = rtValue === -1 || lValues.length === 0;

            if (!invalidSelection) {


                let txt = `
<style>

table.table-sroh td {
    border-left: 1px solid #000;
    border-right: 1px solid #000;
}

table.table-sroh td:first-child {
    border-left: none;
}

table.table-sroh td:last-child {
    border-right: none;
}

table.table-sroh th {
    border-left: 1px solid #000;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
    border-top: 1px solid #000;
}

table.table-sroh th:first-child {
    border-left: none;
}

table.table-sroh th:last-child {
    border-right: none;
}


table.table-sroh caption {
    font-weight: bold;
    font-size: 1.2em;
    caption-side: top;
}


table.table-sroh tr.border-bottom, table.table-sroh td.border-bottom {
    border-bottom: 1px solid #000 !important;
}

table.table-sroh tr.shaded, table.table-sroh td.shaded, table.table-sroh th.shaded {
 background-color: #E5EEFD;
}

</style>
        <table role="table" class="table table-responsive table-sroh mt-4">
        <caption>${titleData.Title}</caption>
            <thead>
            <tr>
            <th style="width:15%; vertical-align:top">Key</th>`;

                txt += `<th class="shaded">${dataRow.TypeOfMaterial}</th>`

                lValues.forEach((x) =>
                    txt += `<th class="shaded">Minimum passes/lift for compacted lift thickness up to: ${x}</th>`
                );


                txt += `
            </tr>
            </thead>
            <tbody>


           
            <tr class="border-bottom">
            <td>Vibrotamper</td>
            <td>50 kg minimum</td>`;


                lValues.forEach((x) =>
                    txt += `<td>${dataRow.Vibrotamper50.find(i => i.key === x).value}</td>`
                );


                txt += `
            </tr>

            <tr>
            <td rowspan="4"  class="border-bottom">Single drum<br />Vibrating roller</td>
            <td class="shaded">600-1000 kg/m</td>`;


                lValues.forEach((x) =>
                    txt += `<td class="shaded">${dataRow.SingleDrum600.find(i => i.key === x).value}</td>`
                );


                txt += `
            </tr>


            <tr>
            <td>1000-2000 kg/m</td>`;


                lValues.forEach((x) =>
                    txt += `<td>${dataRow.SingleDrum1000.find(i => i.key === x).value}</td>`
                );


                txt += `
            </tr>


            <tr>
            <td class="shaded">2000-3500 kg/m</td>`;


                lValues.forEach((x) =>
                    txt += `<td class="shaded">${dataRow.SingleDrum2000.find(i => i.key === x).value}</td>`
                );


                txt += `
            </tr>

            <tr class="border-bottom">
            <td>Over 3500 kg/m</td>`;


                lValues.forEach((x) =>
                    txt += `<td>${dataRow.SingleDrum3500.find(i => i.key === x).value}</td>`
                );


                txt += `
            </tr>

            <tr>
            <td rowspan="3" class="border-bottom">Twin drum<br />Vibrating roller</td>
            <td class="shaded">600-1000 kg/m</td>`;


                lValues.forEach((x) =>
                    txt += `<td class="shaded">${dataRow.TwinDrum600.find(i => i.key === x).value}</td>`
                );


                txt += `
            </tr>


            <tr>
            <td>1000-2000 kg/m</td>`;


                lValues.forEach((x) =>
                    txt += `<td>${dataRow.TwinDrum1000.find(i => i.key === x).value}</td>`
                );


                txt += `
            </tr>


            <tr class="border-bottom">
            <td class="shaded">Over 2000 kg/m</td>`;


                lValues.forEach((x) =>
                    txt += `<td class="shaded">${dataRow.TwinDrum2000.find(i => i.key === x).value}</td>`
                );


                txt += `
            </tr>




            <tr>
            <td rowspan="2" class="border-bottom">Vibrating plate</td>
            <td>1400-1800 kg/m<sup>2</sup></td>`;


                lValues.forEach((x) =>
                    txt += `<td>${dataRow.VibPlate1400.find(i => i.key === x).value}</td>`
                );


                txt += `
            </tr>


            <tr class="border-bottom">
            <td class="shaded">Over 1800 kg/m<sup>2</sup></td>`;


                lValues.forEach((x) =>
                    txt += `<td class="shaded">${dataRow.VibPlate1800.find(i => i.key === x).value}</td>`
                );


                txt += `
            </tr>






            <tr class="border-bottom">`;

                txt += `<td colspan="${lValues.length + 2}"><b>Alternative compaction plant for restricted areas</b></td>`

                txt += `
            </tr>


            <tr class="border-bottom">
            <td>Vibrotamper</td>
            <td>25 kg minimum</td>
             `;

                txt += `<td rowspan="2" colspan="${lValues.length}">${dataRow.VibrotamperFooter}</td>`

                txt += `
            </tr>


            <tr class="border-bottom">
            <td>Percussive rammer</td>
            <td>10 kg minimum</td>
            
            </tr>

            </tbody>
            <tfoot>
            <tr class="border-bottom">
            <td colspan="${lValues.length + 2}">
                <strong>Notes:</strong>
                <ol class="sroh">
                `;

                    if (txt.search("NP</td>") > -1) {
                        txt += "<li>NP = Not Permitted</li>";
                    }


                    if (txt.search(">NR</td>") > -1) {
                        txt += "<li>NR = Not Recommended</li>";
                    }

                    //if (txt.search("#</td>") > -1) {
                    //    txt += "<li># = Vibrotamper not recommended on permanent surface course of trenches > 500 mm</li>";
                    //}

                txt += `
				    <li>Single drum vibrating rollers are vibrating rollers providing vibration on only one drum</li>
				    <li>Twin drum vibrating rollers are vibrating rollers providing vibration on two separate drums</li>
				    <li>Mechanical pole tampers may be considered for compaction around iron work.</li>
			    </ol>
            </td>
            </tr>
            </tfoot>
            </table>
            `;

               // render the table... 

                $get("tblRequirements").innerHTML = txt;

            }
            else {
                $get("tblRequirements").innerHTML = "";
            }

        };

        $get("btnShowRequirements").addEventListener("click", btnShowRequirementsClick);

    });

})();


